import React from 'react';

import {useRunsQueryContext} from '../../../state/runs/hooks';
import {getPanelSpec} from '../../../util/panelTypes';
import {useIsPanelEditButtonVisible} from '../../Panel/hooks/useIsPanelEditButtonVisible';
import {usePanelContext} from '../../Panel/PanelContextProvider';
import {EditPanelWithModalButton} from '../../Panel/PanelEditButton';

export const ReportPanelEditButton = () => {
  // Reports can support multiple run sets, so we need to grab the entity name
  // from the refs rather than from the report URL
  const {entityName} = useRunsQueryContext();

  const {panel} = usePanelContext();
  const isPanelEditButtonVisible = useIsPanelEditButtonVisible(
    entityName,
    panel.viewType
  );
  const panelSpec = getPanelSpec(panel.viewType);

  if (!isPanelEditButtonVisible) {
    return null;
  }
  if (panelSpec.settingsDrawerOnly) {
    // Settings drawer doesn't exist in reports yet, so panels without an edit
    // modal (marimo) can only be edited in the workspace
    return null;
  }

  return <EditPanelWithModalButton buttonSize="sm" />;
};
